<zbp-modal-template
  [modalHeader]="scoreDetailsModalHeader"
  [bodyContent]="scoreDetailsModalBody"
  [footerContent]="scoreDetailsModalFooter"
  [footerLeftContent]="scoreDetailDeleteScores"
  [isScrollable]="true"
>
  <ng-template #scoreDetailsModalHeader>
    <div class="d-flex flex-row justify-content-between w-100 align-items-center" id="scoreDetailsModalHeader">
      <h1 class="modal-template-header-text h2">{{'shared-score-detail-header' | translate }}</h1>
      <div class="button-wrapper">
        @if(allowEdit && !!parts && editableStatuses.includes(assessmentStatus)) {
          <zbp-button-component
            theme="icon"
            [iconName]="zbpIconNames.pencil"
            (clickHandler)="enableEditMode()"
            type="button"
            [showSpinner]="isSaving"
            [disabled]="isEditing"
            class="text-uppercase"
            [ariaLabel]="'shared-score-detail-label-edit' | translate">
          </zbp-button-component>
        }
        <zbp-button-component
          theme="icon"
          [iconName]="zbpIconNames.printer"
          [showSpinner]="isSaving"
          (clickHandler)="print()"
          type="button"
          [ariaLabel]="'shared-score-detail-label-print' | translate">
        </zbp-button-component>
      </div>
    </div>
  </ng-template>
  <ng-template #scoreDetailsModalBody>
    <div
      id="groupModalContainer"
      class="modal-template"
      [cdkTrapFocus]="isEditing"
      [cdkTrapFocusAutoCapture]="isEditing"
    >
      <zbp-score-detail-view
        [studentName]="studentName"
        [className]="className"
        [productName]="productName"
        [activityName]="activityName"
        [completedOn]="completedOn"
        [showCompletedOn]="showCompletedOn"
        [lastOverriddenUserName]="lastOverriddenUserName"
        [lastOverriddenOn]="lastOverriddenOn"
        [showLastOverriddenMessage]="showLastOverriddenMessage"
        [wordListLevel]="wordListLevel"
        [columns]="columns"
        [rows]="rows"
        [printableHeaders]="printableHeaders"
        [showSpinner]="isLoading"
      />
    </div>
  </ng-template>

  <ng-template #scoreDetailDeleteScores>
    <div>
      @if(allowEdit && !!parts && editableStatuses.includes(assessmentStatus)) {
        <zbp-button-component
          theme="icon"
          [iconName]="zbpIconNames.x_cross_circle"
          (clickHandler)="deleteScores()"
          [theme]="'primaryText'"
          type="button"
          [disabled]="isEditing"
          class="text-uppercase"
          [label]="'Delete All Scores'">
        </zbp-button-component>
      }
    </div>
  </ng-template>

  <ng-template #scoreDetailsModalFooter>
    <div class="button-wrapper">
      <zbp-button-component
        theme="ghostFocus"
        [label]="'shared-button-close' | translate"
        (click)="dismiss()"
        type="button"
        [disabled]="isSaving"
        class="text-uppercase">
      </zbp-button-component>
      <zbp-button-component
        *ngIf="!!parts && (isEditing || hasUnscoredManualSection)"
        theme="primary"
        [label]="'shared-button-save' | translate"
        (click)="save()"
        type="button"
        [disabled]="addSubFormControls.pristine || isSaving"
        class="text-uppercase score-detail-save-button">
      </zbp-button-component>
    </div>
  </ng-template>
</zbp-modal-template>

<ng-template #standardsPrintOptionModalBody>
  <p>{{ 'score-detail-print-standards-message' | translate }}</p>
  <zbp-toggle-switch
    [isChecked]="printStandards"
    [toggleLabel]="toggleLabel"
    [internalId]="'printStandardsToggle'"
    (toggleChange)="printStandards = $event"
  >
  </zbp-toggle-switch>
</ng-template>

<ng-template #deleteScoresConfirmationModalBody>
  <p>By proceeding, <strong>all scores for this test - including both automatically scored and manually scored results</strong> - will be permanently deleted. If this test was taken in another class, choosing to delete these scores will delete them everywhere they appear. Other classes, including the class they originated from, and school administrators, will no longer be able to view these scores. <strong>This action is irreversible.</strong></p>
  @if (deleteScoresInfo.length > 1) {
    <p>
      This student has previously completed this test. The assessment history below shows both their current and their previous score. If you proceed, the current score will be replaced with the previously achieved score.
    </p>
  }
  <p>
    If you wish to delete only specific manually scored items, please use the edit feature to delete individual scores instead.
  </p>
  <p>
    Are you sure you want to continue?
  </p>
  <p class="assessment-history">Assessment History</p>
  <div class="table-container">
    <table class="simple-table">
      <thead>
      <tr>
        <th>Start date/time</th>
        <th>Completed date/time</th>
        <th>Status</th>
        <th>Score</th>
        <th>Available</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of deleteScoresInfo">
        <td>{{ item.createdOn }}</td>
        <td>{{ item.completedOn }}</td>
        <td>{{ item.assessmentStatus }}</td>
        <td>{{ item.score }}</td>
        <td>{{ item.assessmentAvailableDescription }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>
